import type { InstallationType } from "@/base/sensor-configurations"
import type { Reducer } from "@reduxjs/toolkit"

import { loadActiveFarmAsync } from "@/base/load-app"
import * as Models from "@/redux/models"
import i18n from "@/translations/i18n"
import { createSlice } from "@reduxjs/toolkit"

export type NamedDeviceActionsState =
  Models.ModelState<Models.NamedDeviceAction>

const INITIAL_STATE: NamedDeviceActionsState = {
  entities: {},
  ids: [],
}
const slice = createSlice({
  extraReducers: (builder) => {
    return builder.addCase(loadActiveFarmAsync.fulfilled, (state, action) => {
      Models.namedDeviceAction.adapter.setAll(
        state,
        action.payload.namedDeviceActions ?? [],
      )
    })
  },
  initialState: INITIAL_STATE,
  name: "namedDeviceActions",
  reducers: {},
})
const namedDeviceActions: Reducer<NamedDeviceActionsState> = slice.reducer
export default namedDeviceActions
export const formatDeviceActionDisplayName = (
  action:
    | Pick<
        Models.NamedDeviceAction,
        "displayName" | "expectedOutcome" | "id" | "name"
      >
    | null
    | undefined,
) => {
  if (action) {
    return action.displayName ?? action.name ?? `Action ${action.id}`
  }
  return i18n.t("deviceActions:unknownAction")
}

export function canScheduleDurationToggle(
  deviceInstallationType: InstallationType,
) {
  return (
    deviceInstallationType === "pump_on_off" ||
    deviceInstallationType === "valve"
  )
}
export function canScheduleActions(deviceInstallationType: InstallationType) {
  return (
    deviceInstallationType === "pump" ||
    deviceInstallationType === "pump_vfd" ||
    deviceInstallationType === "pump_on_off" ||
    deviceInstallationType === "pump_off_only" ||
    deviceInstallationType === "valve"
  )
}
export function canUseDelayedShutdown(
  deviceInstallationType: InstallationType,
) {
  return (
    canScheduleActions(deviceInstallationType) ||
    deviceInstallationType === "reel_with_booster_off_only"
  )
}

export function getDeviceActionSelectOptions(
  actions: Models.NamedDeviceAction[] | null | undefined,
) {
  return (
    actions?.map((action) => ({
      label: formatDeviceActionDisplayName(action),
      value: `${action.id}`,
    })) ?? []
  )
}
